import React from 'react';
import { hasAdministrationRightsOrIsEventStatusPlannedInProgressAndCurrentUserIsInstructor, getNextStatus } from 'utils/event-utils';
import { EventFormStore, EventFormViewModel } from 'stores/events/event-form-store';

interface Props {
  eventFormStore: EventFormStore;
  readOnly: boolean;
  onNextStatus?: () => void;
}

const EventNextStatusButtonTw: React.FC<Props> = ({ eventFormStore, readOnly, onNextStatus }) => {
  const event: EventFormViewModel = eventFormStore.state.item;
  if (!event) return null;

  const isVisible =
    hasAdministrationRightsOrIsEventStatusPlannedInProgressAndCurrentUserIsInstructor(event) &&
    getNextStatus(event)?.toString() !== 'Closed';

  if (!isVisible) return null;

  return (
    <button
      type="button"
      className="flex-1 py-2 rounded border border-gray-300 text-gray-700 font-semibold hover:bg-gray-100 transition-all text-sm"
      disabled={!readOnly}
      onClick={onNextStatus}
    >
      Next Status→
    </button>
  );
};

export default EventNextStatusButtonTw;
